import axios, { AxiosError, AxiosInstance } from "axios";
import { openLogoutModal } from "../../hooks/LogoutModalContext/controller";

export const setupApiClient = (): AxiosInstance => {
  const api = axios.create({
    baseURL:
      process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_PROD_API_URL
        : process.env.REACT_APP_DEV_API_URL,

  });

  api.interceptors.request.use((config) => {
  config.headers["TENNANT"] = "ARP"; 
  return config;
});

  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error: AxiosError) => {
      if (error.response && error.response.status === 403) {
        openLogoutModal();
      }
      return Promise.reject(error);
    }
  );

  return api;
};
